export const DEFAULT_CHANNEL_IMAGE = "default-channel";
